import { useEffect } from "react";
import { EdicaoLayoutPersonalizadoOff } from "src/components/projetos/edicao/layouts/EdicaoLayoutPersonalizadoOff";
import { ProjetosFormInicialPersonalizadoOffGrid } from "src/components/projetos/personalizados_offgrid/containers/Formulario/FormInicial";
import { appStore } from "src/framework/store/AppStore";

const PAGE_TITLE = "Edição projeto personalizado offgrid";

export const ProjetosFormInicialPersonalizadoOffEdicaoPage = () => {
  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])

  return (
    <EdicaoLayoutPersonalizadoOff>
      <div className="container">
        <div className="row">
          <div className="X12">
            <ProjetosFormInicialPersonalizadoOffGrid />
          </div>
        </div>
      </div>
    </EdicaoLayoutPersonalizadoOff>
  );
};
